import { ReactElement } from 'react';
import { Section } from '@client/catalog/components/Facets/Section';
import { getFacetFilterKey, translateFilterName } from '@client/catalog/utils/facets';
import { useTranslate } from '@client/i18n/hooks';
import { Accordion, Section as AccordionSection } from 'b2b-components/theme/components/Accordion';
import { Range } from 'b2b-components/theme/components/Form/Range';
import { FilterGroup } from 'b2b-common/core/catalog/Catalog.types';
import { Props } from './Facets.types';
import './Facets.scss';

export const Facets = ({
  activeSectionIndexArray,
  nonEmptyFilters,
  onFilterCheckboxChange,
  onFilterRangeChange,
  onActiveSectionIndexArrayChange,
}: Props): ReactElement => {
  const t = useTranslate();
  const accordionId = 'Facets/Accordion/Id';
  const minId = 'Facets/Accordion/minId';
  const maxId = 'Facets/Accordion/maxId';

  if (!nonEmptyFilters.length) {
    return null;
  }

  const renderSection = (
    filterGroup: FilterGroup,
  ): ReactElement => {
    let selectable = null;
    let slider = null;

    if (filterGroup.elements.length) {
      selectable = (
        <Section
          filterGroup={filterGroup}
          onCheckboxChange={onFilterCheckboxChange}
          dataAttributes={{ 'data-testid': `formSelectableSection-${filterGroup.name}` }}
        />
      );
    }

    if (filterGroup.slider) {
      const {
        checked,
        minValue,
        maxValue,
        selectedMinValue,
        selectedMaxValue,
      } = filterGroup.slider;
      const filterKey = getFacetFilterKey(filterGroup.field, checked);
      const handleRangeChange = onFilterRangeChange.bind(null, filterGroup.field);
      slider = (
        <Range
          rangesIds={{
            minId,
            maxId,
          }}
          buttonLabel='OK'
          defaultValue={{
            min: selectedMinValue,
            max: selectedMaxValue,
          }}
          onChange={handleRangeChange}
          text={{
            minPlaceholder: `${minValue}`,
            maxPlaceholder: `${maxValue}`,
          }}
          key={filterKey}
          dataAttributes={{ 'data-testid': `formRangeSection-${filterGroup.name}` }}
        />
      );
    }

    return (
      <AccordionSection
        sectionId={accordionId}
        key={filterGroup.field}
        title={translateFilterName(t, filterGroup.field, filterGroup.name)}
      >
        {selectable}
        {slider}
      </AccordionSection>
    );
  };

  return (
    <form className='Facets'>
      <div className='Catalog-FiltersHeading'>{t('Filter results')}</div>

      <Accordion
        isMultiple
        onChange={onActiveSectionIndexArrayChange}
        openIndexArray={activeSectionIndexArray}
      >
        {nonEmptyFilters.map((filterGroup) => renderSection(filterGroup))}
      </Accordion>
    </form>
  );
};
